import { PresignedUrlReq } from '@rp/shared/models';

const getPresignedUrlPayload = (expiration?: string): PresignedUrlReq => {
  const payload: PresignedUrlReq = {} as PresignedUrlReq;

  payload.filePath = generateUniqueId();

  if (expiration) {
    payload.expiration = expiration;
  }

  return payload;
};

const generateUniqueId = (): string => {
  const randomNumber = Math.floor(Math.random() * 10 ** 10);
  const randomString = randomNumber.toString(36).substring(2, 7);

  return `Id_${randomNumber * Math.floor(Math.random() + 2)}${randomString}`;
};

export const PresignedUrlAdapter = {
  getPresignedUrlPayload,
};
